// extracted by mini-css-extract-plugin
export var messageSideLeft = "_l0-1";
export var messageSideRight = "_l0-2";
export var orderLookupBubbleContainer = "_l0-0";
export var submitButton = "_l0-3";